<ng-container *transloco="let t; read: TRANSLATION_SCOPE">
  <p data-qa="test-auth-info-label">{{ t(getMessageDependingOnRoute()) }}</p>
  <rx-applications-contact-instructions></rx-applications-contact-instructions>
</ng-container>